<template>
  <div class="forgotPassword">
    <div class="forgotPassword__panelWrapper">
      <div
        class="forgotPassword__row flex flex-col gap-4 text-secondary-base sm:mb-0 mb-3"
      >
        <div class="forgotPassword__row">
          <p class="text-[32px] leading-[40px] font-extrabold">
            Need help with your account?
          </p>
        </div>
        <div class="forgotPassword__row">
          <p class="text-sm leading-[21px] font-medium text-greyscale-700">
            Enter the email address associated with your account, and we will
            send you a link to reset your password.
          </p>
        </div>
      </div>
      <div class="forgotPassword__row flex flex-col">
        <div class="forgotPassword__column">
          <Input
            @enter="enter"
            id="email"
            autocomplete="form.email"
            v-model="form.email"
            type="email"
            placeholder="Business Email"
            :error="$v.form.email.$anyError"
          />
        </div>
        <span class="error mt-[10px]" v-if="emailLengthControl">
          The email cannot be left blank
        </span>
        <span
          class="error mt-[10px]"
          v-if="$v.form.email.$anyError && !emailLengthControl"
          >The email address you entered is not in the correct format.</span
        >
      </div>
      <div class="forgotPassword__row" v-if="showSuccessText">
        <div class="forgotPassword__column">
          <p class="text-md">
            If an account is associated with your provided email address, you
            will receive a password reset email shortly.
          </p>
        </div>
      </div>
      <div class="forgotPassword__row flex-col gap-[10px]">
        <div class="forgotPassword__column">
          <Button
            @click="sendResetEmail"
            class="primary large w-full"
            :disabled="disabled"
            >{{ buttonText }}</Button
          >
        </div>
        <div class="forgotPassword__column">
          <Button @click="goToSignIn" class="secondary large w-full sm:hidden"
            >Go Back</Button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Input from "@/components/Input";
import Button from "@/components/Button";
import { mapActions } from "vuex";
import { email, required } from "vuelidate/lib/validators";

export default {
  name: "ForgotPassword",
  components: {
    Button,
    Input,
  },
  data() {
    return {
      form: {
        email: "",
      },
      error: "",
      errors: [],
      showSuccessText: false,
      emailLengthControl: false,
      disabled: false,
    };
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
  methods: {
    ...mapActions(["forgotPassword"]),
    sendResetEmail() {
      this.errors = [];
      this.$v.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else {
        this.forgotPassword({
          email: this.form.email,
        })
          .then(() => {
            this.showSuccessText = true;
            this.$router.push("/forgot-password/request-sended");
            this.disabled = false;
          })
          .catch(() => {
            this.error = "Email is wrong";
          });
        this.disabled = true;
      }
    },
    enter() {
      this.sendResetEmail();
      if (!this.form.email.length) {
        this.emailLengthControl = true;
      }
    },
    goToSignIn() {
      this.$router.push({ path: "/" });
    },
  },
  watch: {
    "form.email": {
      handler() {
        this.emailLengthControl = !this.form.email.length;
      },
    },
  },
  computed: {
    buttonText() {
      return !this.disabled ? "Send Link" : "Generating a recovery link...";
    },
  },
};
</script>
<style lang="css">
@import "index.module.css";
</style>
